import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

import { InfoTooltip } from '@dashboard/components/Tooltip';

import LabelDescription from '../LabelDescription';

const propTypes = {
  htmlFor: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.node]).isRequired,
  className: PropTypes.string,
};

const defaultProps = {
  htmlFor: '',
  className: '',
};

const Label = ({
  className,
  children,
  htmlFor,
  isInline,
  disabled,
  optional,
  tooltip,
  tags = [],
  description,
  ...props
}) => (
  <>
    <label
      disabled={disabled}
      htmlFor={htmlFor || null}
      className={clsx(`block text-gray-900 pointer font-medium mb-1 text-sm`, className, {
        '!text-base !mb-0': isInline,
        '!mb-0.5': description,
        'opacity-50': disabled,
      })}
      {...props}
    >
      {children}

      {tooltip && <InfoTooltip>{tooltip}</InfoTooltip>}

      {optional &&
        (tags && tags.length > 0 ? (
          <span className="text-gray-500 ml-1 text-sm font-normal">
            (optional, {tags.join(' ,')})
          </span>
        ) : (
          <span className="text-gray-500 ml-1 text-sm font-normal">(optional)</span>
        ))}

      {!optional && tags && tags.length > 0 && (
        <span className="text-gray-500 ml-1 text-sm font-normal">({tags.join(' ,')})</span>
      )}
    </label>

    {description && <LabelDescription>{description}</LabelDescription>}
  </>
);

Label.propTypes = propTypes;
Label.defaultProps = defaultProps;

export default Label;
